
export default {
    name: 'antecedent-allergologie-environnement',
    components: {},
    props: ["consultation", "activeRole"],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_facteur_pro: true,

            save_loading: false,
            
            atcd_allergo_p: {
                v_model: []
            },
            fields: [
                'tabagisme', 'tabagisme_mention', 'pollution',
                'pollution_mention', 'toxique', 'toxique_mention',
                'acarien', 'acarien_mention', 'blatte',
                'blatte_mention', 'animaux', 'animaux_mention',
                'moisissures', 'moisissures_mention', 'pollen_graminee',
                'pollen_graminee_mention', 'certaine_moisissures', 'certaine_moisissures_mention',
                'trophallergene'
            ],
        }
    }, 

    computed: {
        antecedent_allergo_environnement() {
            return this.$store.getters["antecedent_allergo_environnement"];
        },
    },
    mounted() {
        this.listeChampATCDAllergoEnvironnement()
    },

    methods: {
        initFields() {
            var i = 0
            
            this.fields.forEach((fld, index) => {
                var v = ''
                if (this.antecedent_allergo_environnement.length > 0) {
                    v = this.antecedent_allergo_environnement[index]['field_content']
                }
                
                this.atcd_allergo_p.v_model.push({
                    field_name: fld,
                    value: v
                })
                i++

                if (i == (this.fields.length - 1)) {
                    this.is_loading = false
                }
            });
        },

        async listeChampATCDAllergoEnvironnement() {
            this.is_loading = true
            
            let filter_data = {
                consultation_id: this.consultation.id,
                data_type: 'antecedent_allergologie_environnement',
                est_en_cours: true
            }

            this.$store.dispatch('getConsultationAntecedent', filter_data).then(() => {
                this.initFields()
            })
        },

        toggleSection(v) {
            this.is_facteur_pro = v
        },

        saveAntecedent() {
            this.save_loading = true

            let data = {
                consultation_id: this.consultation.id,
                data_type: 'antecedent_allergologie_environnement',
                antecedents: this.atcd_allergo_p.v_model
            }

            this.$store.dispatch('saveConsultationAntecedent', data).then((response) => {
                console.log(response)
                if (response > 0) {
                    this.listeChampATCDAllergoEnvironnement()
                }

                this.save_loading = false
            })
        }
    }
}


